export const VERIFICATION_METHODS = [
  'meta_log',
  'recipient_confirmation',
  'company_log',
];

const deliveryFrom = attributes =>
  attributes?.teletel_meta_delivery || attributes?.teletelMetaDelivery;

// MessageList camel-cases nested attributes; API responses keep snake_case.
// This projection controls presentation only. The retry endpoint rechecks all
// permissions, timing and attempt ownership against the stored server state.
export const getMetaDelivery = (_additionalAttributes, contentAttributes) => {
  // The current API derives this projection from the canonical attempt ledger.
  // A historical flat marker in additional attributes is not that projection.
  const delivery = deliveryFrom(contentAttributes);
  if (!delivery) return null;
  return {
    state: delivery.state,
    attemptId: delivery.attempt_id || delivery.attemptId,
    unknownSince: delivery.unknown_since || delivery.unknownSince,
    eligibleAt: delivery.eligible_at || delivery.eligibleAt,
    deadlineAt: delivery.deadline_at || delivery.deadlineAt,
    enqueueRetryable: Boolean(
      delivery.enqueue_retryable || delivery.enqueueRetryable
    ),
    confirmedById: delivery.confirmed_by_id || delivery.confirmedById,
    enqueueOrigin: delivery.enqueue_origin || delivery.enqueueOrigin,
    verificationMethod:
      delivery.verification_method || delivery.verificationMethod,
    duplicateDeliveryPossible: Boolean(
      delivery.duplicate_delivery_possible || delivery.duplicateDeliveryPossible
    ),
  };
};

export const canRecoverEnqueue = (delivery, role, userId) =>
  delivery?.state === 'authorized' &&
  delivery.enqueueRetryable &&
  Boolean(delivery.attemptId) &&
  Number(userId) > 0 &&
  Number(delivery.confirmedById) === Number(userId) &&
  (delivery.enqueueOrigin === 'retry' ||
    (delivery.enqueueOrigin === 'human' &&
      role === 'administrator' &&
      VERIFICATION_METHODS.includes(delivery.verificationMethod)));

export const canConfirmDelivery = (delivery, role, now = Date.now()) => {
  if (role !== 'administrator' || delivery?.state !== 'unknown') return false;
  if (!delivery.attemptId || !delivery.eligibleAt) return false;
  const eligibleAt = Date.parse(delivery.eligibleAt);
  return Number.isFinite(eligibleAt) && now >= eligibleAt;
};

export const deliveryErrorKey = error => {
  const code = error?.response?.data?.code;
  const keys = {
    TELETEL_META_CONFIRMATION_REQUIRED: 'CONFIRMATION_REQUIRED',
    TELETEL_META_CONFIRMATION_TOO_EARLY: 'TOO_EARLY',
    TELETEL_META_ATTEMPT_CHANGED: 'ATTEMPT_CHANGED',
    TELETEL_META_DASHBOARD_REQUIRED: 'FORBIDDEN',
    TELETEL_META_ADMIN_REQUIRED: 'FORBIDDEN',
    TELETEL_META_RECIPIENT_NOT_ELIGIBLE: 'RECIPIENT_NOT_ELIGIBLE',
    TELETEL_META_CSAT_TEMPLATE_CHANGED: 'CSAT_TEMPLATE_CHANGED',
    TELETEL_META_PREVIOUS_UNRESOLVED: 'PREVIOUS_UNRESOLVED',
    TELETEL_META_ENQUEUE_FAILED: 'ENQUEUE_FAILED',
  };
  return `TELETEL_DELIVERY_UNKNOWNS.ERRORS.${keys[code] || 'RETRY_FAILED'}`;
};
